import { APP_INITIALIZER, ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { AppMaterialModule } from '../app-material.module';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ErrorComponent } from './components/error/error.component';
import { ChatAgentComponent } from './components/chat-agent/chat-agent.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServerErrorInterceptor } from './interceptors/server-error.interceptor';
import { HttpRequestInterceptor } from './interceptors/http-request.interceptor';
import { PreInitService } from './services/pre-init.service';
import { PreInitSitefinityContentService } from './services/pre-init-sitefinity-content.service';
import { mergeMap } from 'rxjs/operators';
import { OKTA_CONFIG_PROVIDER } from './services/okta.config.provider';
import { WINDOW_PROVIDERS } from './services/window.service';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { LoggedInNavlistComponent } from './components/sidenav/logged-in-navlist/logged-in-navlist.component';
import { LoggedOutNavlistComponent } from './components/sidenav/logged-out-navlist/logged-out-navlist.component';
import { SharedModule } from '../shared/shared.module';
import { GlobalErrorHandler } from './handler/global-error-handler';
import { SnackbarService } from './services/snackbar/snackbar.service';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { ADPComponentsModule, ADPServicesModule } from 'digital-core';
import { PGHAppLoadService } from './services/pgh-app-load.service';



const COMPONENTS = [
  ChatAgentComponent,
  ErrorComponent,
  FooterComponent,
  HeaderComponent,
  LoggedInNavlistComponent,
  LoggedOutNavlistComponent,
  SidenavComponent
];

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 0,
    exitDuration: 0
  }
};

@NgModule({
  declarations: [
    ...COMPONENTS
  ],
  imports: [
    AppMaterialModule,
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    SharedModule,
    // OktaAuthModule.forRoot({ oktaAuth }),

  ],
  exports: [
    ...COMPONENTS,
    ADPServicesModule,
    ADPComponentsModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (init: PreInitService, sitefinityInit: PreInitSitefinityContentService) => {
        return () => init.loadConfig()
          .pipe(mergeMap(() => sitefinityInit.loadConfig()))
          .toPromise();
      },
      deps: [PreInitService, PreInitSitefinityContentService, PGHAppLoadService],
      multi: true
    },
    //OKTA_CONFIG_PROVIDER,
    WINDOW_PROVIDERS,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 4000 }},
    {
      // processes all errors
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ]
})

export class CoreModule {
  // Ensure this is loaded only once
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    snackbarService: SnackbarService, // Needed to register the snackbar service so it can automatically listen for snackbar notification events.
  ) {
    if (parentModule) {
      throw new Error(`$CoreModule has already been loaded. Import CoreModule in the AppModule only.`);
    }
  }
}
